import presentMap from './reducers';

export default presentMap;
